module.exports = __webpack_public_path__ + "7fd89ff586368ebc0d05854d5cefc652.svg";